module.exports = "<span dropdown> <button dropdown-toggle type=button class=\"button-secondary dropdown toggle-content-trigger\"> <span class={{model}}></span> </button> <ul class=\"dropdown-menu init toggle-content list-unstyled\" dropdown-menu> <li ng-repeat=\"icon in iconSet\" class=inline> <button type=button class=\"button-secondary inline\" ng-click=setIcon(icon)> <span class=\"{{ icon }}\"></span> </button> </li> </ul> </span> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/directives/iconpicker.html
// module id = 502
// module chunks = 0